import React from "react";

const Page2 = () => (
  <div>
    <h1>Page2</h1>
  </div>
);

export default Page2;
